import { render, staticRenderFns } from "./comprasMedicina.vue?vue&type=template&id=487ac12e&scoped=true"
import script from "./comprasMedicina.vue?vue&type=script&lang=js"
export * from "./comprasMedicina.vue?vue&type=script&lang=js"
import style0 from "./comprasMedicina.vue?vue&type=style&index=0&id=487ac12e&prod&lang=css"
import style1 from "./comprasMedicina.vue?vue&type=style&index=1&id=487ac12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487ac12e",
  null
  
)

export default component.exports